import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { GraduationCap, TrendUp } from "@phosphor-icons/react";

export default function SkillMarket() {
  const [skills, setSkills] = useState([]);

  useEffect(() => {
    api.get("/skills/market").then(({ data }) => setSkills(data));
  }, []);

  const max = Math.max(1, ...skills.map((s) => s.demand_score));

  return (
    <div className="p-4 md:p-6 lg:p-8 max-w-5xl mx-auto" data-testid="skill-market-page">
      <div className="mb-6 flex items-center gap-3">
        <GraduationCap size={28} />
        <div>
          <div className="text-[10px] uppercase tracking-[0.2em] text-zinc-500">Skill Economy</div>
          <h1 className="text-3xl sm:text-4xl tracking-tight font-bold">Where demand is right now</h1>
        </div>
      </div>

      <div className="border border-border bg-background">
        <table className="w-full text-sm" data-testid="skill-market-table">
          <thead className="border-b border-border">
            <tr className="text-[10px] uppercase tracking-[0.2em] text-zinc-500">
              <th className="text-left py-2 px-3">Skill</th>
              <th className="text-right py-2 px-3 hidden md:table-cell">Open tasks</th>
              <th className="text-right py-2 px-3 hidden md:table-cell">Credits in demand</th>
              <th className="text-left py-2 px-3 w-1/3">Demand</th>
              <th className="text-right py-2 px-3">Score</th>
            </tr>
          </thead>
          <tbody>
            {skills.map((s) => (
              <tr key={s.skill} className="border-b border-border" data-testid={`skill-row-${s.skill}`}>
                <td className="py-2 px-3 font-mono uppercase text-xs tracking-wider">{s.skill}</td>
                <td className="py-2 px-3 text-right font-mono hidden md:table-cell">{s.open_tasks}</td>
                <td className="py-2 px-3 text-right font-mono text-[#E1252A] font-semibold hidden md:table-cell">{s.total_credits_in_demand}</td>
                <td className="py-2 px-3">
                  <div className="h-2 bg-zinc-100 dark:bg-zinc-800 rounded-sm overflow-hidden">
                    <div className="h-full bg-[#E1252A]" style={{ width: `${(s.demand_score / max) * 100}%` }} />
                  </div>
                </td>
                <td className="py-2 px-3 text-right font-mono">{Math.round(s.demand_score)}</td>
              </tr>
            ))}
            {skills.length === 0 && (
              <tr><td colSpan={5} className="text-center py-12 text-sm text-zinc-500">No skill demand data yet. Post a few tasks to see this come alive.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
